import React from 'react';
import { Store } from 'lucide-react';

/*
  `/scan` ya no escanea.

  Era una pantalla pública con un desplegable de tiendas: cualquiera con la URL
  podía canjear, y a nombre de la tienda que eligiera. Ahora cada tienda entra
  por su propio enlace (`/t/{slug}`) y abre con su PIN, así que la tienda deja
  de ser algo que se elige en un formulario.

  La ruta se conserva a propósito en vez de devolver un 404: hay cajas con este
  enlace guardado en favoritos o pegado en el monitor, y quien caiga aquí
  merece saber qué hacer en vez de encontrarse una página rota. Se puede
  retirar cuando todas las tiendas estén operando con su enlace nuevo.
*/
const ScanQR = () => {
  return (
    <div className="min-h-screen bg-black px-6 py-16">
      <div className="max-w-md mx-auto text-center space-y-5">
        <div className="w-14 h-14 rounded-2xl bg-white/10 flex items-center justify-center mx-auto">
          <Store className="w-7 h-7 text-white" />
        </div>

        <h1 className="text-3xl font-bold text-white">Esta pantalla cambió</h1>

        <p className="text-[#A2A2A2]">
          Ahora cada tienda tiene su propio enlace de caja. Entra por el enlace de tu tienda y escribe el PIN que te
          dieron; ya no hay que elegir la tienda en una lista.
        </p>

        <div className="bg-white/5 border border-white/10 rounded-2xl p-5 text-left space-y-2">
          <p className="text-white text-sm font-medium">¿No tienes tu enlace?</p>
          <p className="text-[#A2A2A2] text-sm">
            Pídeselo a vondi. Es un enlace por tienda, con un PIN corto que se rota cuando haga falta.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ScanQR;
